import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tiempos-rutas',
  templateUrl: './tiempos-rutas.component.html',
  styleUrls: ['./tiempos-rutas.component.css']
})
export class TiemposRutasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
